<template>
  <div class="m-gallery">
    <a
      class="asset-container"
      @click="openGallery"
    >
      <img
        class="primary-asset"
        v-bind="firstAsset"
        ref="firstAsset"
      >
      <i
        :class="['icon', icon]"
        v-if="firstAssetLoaded"
      />
    </a>
  </div>
</template>

<script>
import 'glightbox/dist/css/glightbox.css'
import map from 'lodash/map'
import pick from 'lodash/pick'
import filter from 'lodash/filter'
import { buildURL } from './../../helpers/media'

export default {
  name: 'Gallery',
  props: {
    assetList: {
      type: Array,
      required: true
    },
    pathPattern: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      gallery: null,
      firstAssetWidth: null,
      firstAssetLoaded: false
    }
  },
  computed: {
    formatedElements () {
      return filter(map(this.assetList, asset => {
        return {
          href: asset.href ? asset.href : ((asset.path && asset.width && this.pathPattern) ? buildURL(this.pathPattern, { ...asset }) : false),
          ...pick(asset, ['title', 'description']),
          alt: asset.title
        }
      }), 'href')
    },
    firstAsset () {
      const firstAsset = this.assetList[0]
      if (!firstAsset) {
        return false
      }

      return {
        alt: firstAsset.title,
        src: firstAsset.href ? firstAsset.href : ((firstAsset.path && this.pathPattern) ? buildURL(this.pathPattern, { ...firstAsset, width: this.firstAssetWidth || '' }) : false)
      }
    },
    icon () {
      if (this.assetList.length > 1) {
        return 'icon-gallery'
      }

      return 'icon-maximize'
    }
  },
  mounted () {
    this.firstAssetWidth = this.$el.offsetWidth
    if (this.$refs.firstAsset.complete) {
      this.firstAssetLoaded = true
    } else {
      this.$refs.firstAsset.onload = () => {
        this.firstAssetLoaded = true
      }
    }
  },
  unmounted () {
    if (this.gallery) {
      this.gallery.destroy()
    }
  },
  methods: {
    async initGallery () {
      const Glightbox = (await import('glightbox')).default
      this.gallery = new Glightbox({
        elements: this.formatedElements,
        openEffect: 'fade',
        closeEffect: 'fade',
        zoomable: false
      })
    },
    onLoaded () {
      this.firstAssetLoaded = true
    },
    async openGallery () {
      if (!this.gallery) {
        await this.initGallery()
      }
      this.gallery.open()
    },
    closeGallery () {
      this.gallery.close()
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-gallery.less";

.asset-container .icon {
  background-color: @grey-50;
  padding: 0.5em;
  border-radius: 50%;
}
</style>
